// db/dynamic-validators.ts
import { baseqlMetaData } from "@adornis/baseql/metadata/metaDataStore.js";
import { maxLength, minLength } from "@adornis/validation/functions/length.js";
import { nonOptional } from "@adornis/validation/functions/nonOptional.js";
import { Validator } from "@adornis/validation/validator.js";
import { DynamicClass } from "./dynamic-classes.js";
var ValidationString = /* @__PURE__ */ ((ValidationString2) => {
  ValidationString2["NON_OPTIONAL"] = "non_optional";
  ValidationString2["MIN_LENGTH_10"] = "min_length_ten";
  ValidationString2["MAX_LENGTH_10"] = "max_length_ten";
  return ValidationString2;
})(ValidationString || {});
var updateDynamicValidators = async (entityClasses = [DynamicClass._class]) => {
  const dynamicNodesWitDynamicFields = [];
  await baseqlMetaData.entities.forEach((node) => {
    const anyFieldDynamic = Object.values(node.fields).some((field) => field.dynamic);
    if (!node.dynamic && !anyFieldDynamic)
      return;
    dynamicNodesWitDynamicFields.push(node);
  });
  const dynamicClasses = await DynamicClass.getDynamicClassesByClassNames(
    // @ts-expect-error type() results in a adornisEntity
    dynamicNodesWitDynamicFields.map((node) => node.type()._class),
    // @ts-expect-error type() results in a adornisEntity
    [...new Set(entityClasses.map((className) => baseqlMetaData.entities.resolveNode(className).type()._collectionName))]
  )(DynamicClass.allFields);
  for (const dynamicNode of dynamicNodesWitDynamicFields) {
    const fields = dynamicNode.fields;
    const dynamicFields = [];
    for (const field of Object.values(fields)) {
      if (!field.dynamic)
        continue;
      dynamicFields.push(field);
    }
    const dynamicClass = dynamicClasses.find((dynamicClass2) => dynamicClass2.class === dynamicNode.type()._class);
    const validatorOptions = {};
    for (const dynamicField of dynamicFields) {
      const attributeDefinition = dynamicClass?.attributes.find((attribute) => attribute.key === dynamicField.name);
      if (!attributeDefinition || !attributeDefinition.validation)
        continue;
      validatorOptions[attributeDefinition.key] = getValidatorByString(attributeDefinition.validation);
      dynamicField.options.dynamicValidator = attributeDefinition.validation;
    }
    if (Object.keys(validatorOptions).length === 0)
      continue;
    const existingValidator = dynamicNode.type().prototype.validator;
    const existingValidationFunctions = existingValidator.functions;
    dynamicNode.type().prototype.validator = new Validator({ ...existingValidationFunctions, ...validatorOptions });
  }
};
var getValidatorByString = (validationString) => {
  switch (validationString) {
    case "non_optional" /* NON_OPTIONAL */:
      return nonOptional();
    case "min_length_ten" /* MIN_LENGTH_10 */:
      return minLength(10);
    case "max_length_ten" /* MAX_LENGTH_10 */:
      return maxLength(10);
    default:
      return null;
  }
};
export {
  ValidationString,
  getValidatorByString,
  updateDynamicValidators
};
